import { FC } from "react";
import { GridLegacy as Grid } from "@mui/material";

import { IInsightsPageTab } from "@/logic/api";
import { DriverSelector } from '@/components/charts/selectors/driver-selector';
import { StartDateSelector } from '@/components/charts/selectors/start-date-selector';
import { EndDateSelector } from '@/components/charts/selectors/end-date-selector';
import { IntervalSelector } from '@/components/charts/selectors/interval-selector';
import { ReceptionistSelector } from "@/components/charts/selectors/receptionist-selector";
import { DayShiftSelector } from "@/components/charts/selectors/day-shift-selector";
import { SellableDaysSelector } from "@/components/charts/selectors/sellable-days-selector";
interface IFiltersProps {
  criteria?: IInsightsPageTab["criteria"];
}

const CRITERIA_COMPONENT_MAP = new Map([
  [0, DriverSelector],
  [1, StartDateSelector],
  [2, EndDateSelector],
  [3, IntervalSelector],
  [4, ReceptionistSelector],
  [5, DayShiftSelector],
  [6, SellableDaysSelector]
])

export const Filters: FC<IFiltersProps> = ({ criteria }) => (
  <Grid container spacing={2} mb={2} columns={{ lg: 12, md: 6, xs: 4 }}>
    {
      criteria?.map((c, i) => {
        const Component = CRITERIA_COMPONENT_MAP.get(c.type)
        if (!Component) {
          return null
        }

        return (
          <Component
            key={`${c.type}-${i}`}
            config={c.config}
          />
        )
      })
    }
  </Grid>
);

export default Filters
